import React from "react";
import { NavLink as RouterLink } from "react-router-dom";
import clsx from "clsx";
import PropTypes from "prop-types";
import { Button, ListItem, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  item: {
    display: "block",
    paddingTop: 0,
    paddingBottom: 0,
  },
  itemLeaf: {
    display: "flex",
    paddingTop: 0,
    textTransform: "uppercase",
    paddingBottom: 0,
  },
  buttonLeaf: {
    color: "#262626",
    fontWeight: 700,
    padding: "13px 5px 5px 38px",
    height: "60px",
    justifyContent: "flex-start",
    fontFamily: "poppins",
    textTransform: "uppercase",
    letterSpacing: 0,
    width: "100%",
    opacity: 1,
    fontSize: "16px",
    "& li": {
      "& $title": {
        marginLeft: "30px",
      },
    },
    "& $icon": {
      color: "#262626",
    },
    "&:hover": {
      color: theme.palette.text.secondary,
      background: "#F8F8F8",
      borderRadius: "0px",
      "& $icon": {
        color: theme.palette.text.secondary,
      },
    },
    "&.depth-0": {
      "& $title": {
        fontWeight: 400,
        fontSize: "16px",
        whiteSpace: "normal",
        wordBreak: "break-word",
        textAlign: "left",
      },
    },
    [theme.breakpoints.down("sm")]: {
      padding: "12px 12px 12px 24px",
      height: "auto",
      "&.depth-0": {
        "& $title": {
          fontSize: "15px",
          lineHeight: "22px",
        },
      },
    },
  },
  icon: {
    display: "flex",
    alignItems: "center",
    marginRight: "19px",
    color: "#262626",
    "&:hover": {
      color: theme.palette.text.secondary,
    },
    [theme.breakpoints.down("sm")]: {
      marginRight: "14px",
    },
  },
  title: {
    marginRight: "auto",
    whiteSpace: "normal",
    wordBreak: "break-word",
    lineHeight: "1.4",
  },
  active: {
    color: "#FF7F26",
    textTransform: "uppercase",
    fontWeight: 700,
    background: "#F8F8F8",
    padding: "13px 5px 5px 32px",
    borderRadius: "0px",
    "& $title": {
      fontWeight: theme.typography.fontWeightMedium,
    },
    "&:before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      bottom: 0,
      width: "6px",
      borderRadius: "0px 9.322px 9.322px 0px",
      backgroundColor: "#FF7F26",
    },
    "& $icon": {
      color: "#FF7F26",
      "&:hover": {
        color: "#000",
      },
    },
  },
}));

export default function NavItem({
  children,
  className,
  depth,
  href,
  icon: Icon,
  info: Info,
  open: openProp,
  title,
  handleLogoutClick,
  pathname,
  isActive,
  subRoutes,
  setLastActiveTab,
  ...rest
}) {
  const classes = useStyles();

  return (
    <>
      <ListItem
        className={clsx(classes.itemLeaf, className)}
        disableGutters
        key={title}
        {...rest}
      >
        <Button
          activeClassName={isActive ? classes.active : ""}
          className={clsx(classes.buttonLeaf, `depth-${depth}`)}
          component={RouterLink}
          exact={!subRoutes || subRoutes.length === 0}
          to={title !== "LOGOUT" && href}
          onClick={() => {
            if (title !== "LOGOUT") {
              setLastActiveTab(href);
            }
            title === "LOGOUT" && handleLogoutClick();
          }}
        >
          {Icon && <Icon className={classes.icon} size="20" />}
          <span className={classes.title}>{title}</span>
          {Info && <Info />}
        </Button>
      </ListItem>
    </>
  );
}

NavItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  depth: PropTypes.number.isRequired,
  href: PropTypes.string,
  icon: PropTypes.elementType,
  info: PropTypes.elementType,
  open: PropTypes.bool,
  title: PropTypes.string.isRequired,
};

NavItem.defaultProps = {
  open: false,
};
